export const DS_SHADOWS = {
  xs: '0 1px 2px rgba(15, 23, 40, 0.06)',
  sm: '0 0 8px 4px rgba(15, 23, 40, 0.04), 0 1px 3px rgba(15, 23, 40, 0.12), 0 1px 2px rgba(15, 23, 40, 0.04)',
  md: '0 0 10px 6px rgba(15, 23, 40, 0.04), 0 4px 8px rgba(15, 23, 40, 0.12), 0 2px 4px rgba(15, 23, 40, 0.04)',
  lg: '0 0 10px 6px rgba(15, 23, 40, 0.04), 0 12px 18px rgba(15, 23, 40, 0.12), 0 4px 8px rgba(15, 23, 40, 0.04)',
  xl: '0 0 10px 6px rgba(15, 23, 40, 0.04), 0 18px 22px rgba(15, 23, 40, 0.08), 0 8px 10px rgba(15, 23, 40, 0.04)',
  '2xl': '0 24px 46px -10px rgba(15, 23, 40, 0.16)',
} as const;
